export enum BelegFilterListColumn {
  Status = 'status',
  Belegtyp = 'belegtyp',
  Partner = 'partner',
  Belegdatum = 'belegDatum',
  Betrag = 'betrag',
  BelegbucheinAusgang = 'belegbucheinAusgang',
  Kommentar = 'kommentar',
  Actions = 'actions',
}
